import { ensureHidLightDeviceConnected } from '@/service/dynamic_light/frame_writer'
import { deviceManager as hidDeviceManager } from '@hid/device/device_manager'
import { dataProfileManage } from '@hid/snapshot/profile'
import type { KK } from '@hid/define/define'

const toColorMap = (colors: Record<number, number>) => {
  const map = new Map<KK, number>()
  Object.entries(colors).forEach(([key, value]) => {
    map.set(Number(key) as KK, value)
  })
  return map
}

export const imageLightHidWriter = {
  ensureConnected: ensureHidLightDeviceConnected,

  async applyStaticColors(colors: Record<number, number>, light: number | undefined) {
    if (!(await ensureHidLightDeviceConnected({ requestAccess: true }))) {
      return false
    }

    try {
      const profile = dataProfileManage().dataProfile
      if (typeof light === 'number') {
        profile.LightMode.Light = light
      }
      profile.LightLastIsCustom = true
      profile.ColorsDynamic.Run = false
      profile.ColorsCustom = toColorMap(colors)
      dataProfileManage().save()
      await hidDeviceManager.deviceDriver.syncCustomColor()
      return true
    } catch (error) {
      console.warn('image light static colors write failed', error)
      return false
    }
  },
}
